export const ALL_PHOTO_ROUTE_KEY = 'all';

export enum WebsiteOverviewRoutes {
  overview = '/website/overview',
  photos = '/website/photos',
  viewPhoto = '/website/photos/:photoId',
  allPhotos = `/website/photos/${ALL_PHOTO_ROUTE_KEY}`,
}
